"use client";

import { twMerge } from "tailwind-merge";

import { SoftText } from "@/components/text/SoftText";
import { formatDateForOutput } from "@/utils/formatTime/formatDateForOutput";
import { useIsClient } from "@/utils/hooks/useIsClient";

export function DateText({
  dateString,
  className,
}: {
  dateString: string;
  className?: string;
}) {
  const isClient = useIsClient();

  return (
    <SoftText elementType="p" className={twMerge("", className)}>
      {isClient &&
        formatDateForOutput({
          date: new Date(dateString),
          withTime: false,
          withYear: true,
        })}
    </SoftText>
  );
}
